import { createApp } from '@wu/widget-core';
import { LogoShowcase } from './LogoShowcase';
import { meta } from './meta';

export default createApp(meta, LogoShowcase);
